// pickleball offers need their own offer types but are duplicate rewards of the standard ww
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _waivewaits = /*#__PURE__*/ _interop_require_default(require("../ww/waive-waits"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: 'wwpb',
    rewards: [
        _waivewaits.default
    ]
};
